<template>
  <div>
    <k-dialog :title="title" @close="toggleDialog" class="alert-dialog">
      <div v-if="setDeleteDialog" class="delete">
        <p>
          {{ $t("alertComponent.youAreAboutTo") }} {{ $t("alertComponent.delete") }} {{ numberOfOperation }}
          {{ $t("alertComponent.operations") }}.
        </p>
        <p>{{ $t("alertComponent.areYouSureYouWantToProceed") }} {{ $t("alertComponent.deletion") }} ?</p>
      </div>
      <div v-if="setCloneDialog" class="clone">
        <p>
          {{ $t("alertComponent.youAreAboutTo") }} {{ $t("alertComponent.clone") }} {{ numberOfOperation }}
          {{ $t("alertComponent.operations") }}.
        </p>
        <p>{{ $t("alertComponent.areYouSureYouWantToProceed") }} {{ $t("alertComponent.duplication") }}?</p>
      </div>
      <p v-if="isCancelButtonClicked">{{ $t("alertComponent.areYouSureYouWantToExit") }} ?</p>
      <dialog-actions-bar>
        <kbutton class="cancel" @click="toggleDialog">{{ $t("alertComponent.cancel") }}</kbutton>
        <kbutton class="save" @click="showGrid">{{ $t("alertComponent.ok") }}</kbutton>
      </dialog-actions-bar>
    </k-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { Button } from "@progress/kendo-vue-buttons";

export default defineComponent({
  name: "AlertComponent",
  components: {
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    kbutton: Button
  },
  emits: ["hidePopup", "hideCloneDialog", "hideDeleteDialog", "setWindow"],
  props: {
    isCancelButtonClicked: Boolean,
    setCloneDialog: Boolean,
    setDeleteDialog: Boolean,
    numberOfOperation: Number
  },
  data() {
    return {
      title: "",
      setWindow: true
    };
  },
  created() {
    this.setTitle();
  },
  methods: {
    setTitle() {
      if (this.isCancelButtonClicked) this.title = this.$t("alertComponent.pleaseConfirm");
      else if (this.setCloneDialog) this.title = this.$t("alertComponent.clone");
      else if (this.setDeleteDialog) this.title = this.$t("alertComponent.delete");
    },
    toggleDialog() {
      this.$emit("hidePopup", false);
      this.$emit("hideCloneDialog", false);
      this.$emit("hideDeleteDialog", false);
    },
    showGrid() {
      this.setWindow = false;
      this.$emit("setWindow", this.setWindow);
    }
  }
});
</script>
<style scoped>
.save {
  color: #fff;
  background-color: #0054a6;
  border-radius: 5px;
}
.cancel {
  border-radius: 5px;
}
p {
  margin: 25px;
  text-align: center;
}
</style>
